module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub-main column"
  }, [_c('div', {
    staticClass: "sub-page column"
  }, [_c('section', {
    staticClass: "take-place column activity-container container-background"
  }, [_c('div', {
    staticClass: "header-table row"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\tCabinets\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "attached-item row"
  }, [_c('div', {
    staticClass: "phantom-flex"
  }), _vm._v(" "), _c('div', {
    staticClass: "ctn-cta"
  }, [_c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": _vm.showNewCabinet
    }
  }, [_c('span', {
    staticClass: "icon-form-plus"
  }), _vm._v(" Ajouter un cabinet\n\t\t\t\t\t\t\t\t")])])])]), _vm._v(" "), _c('Table', {
    attrs: {
      "elements": _vm.cabinets,
      "clickable": false
    },
    on: {
      "statuschange": _vm.updateStatus,
      "editCabinet": _vm.editCabinet
    }
  }), _vm._v(" "), _c('baseModal', {
    attrs: {
      "show": _vm.showAddCabinet,
      "content": _vm.contentModal,
      "data": {
        currentCabinet: _vm.currentCabinet
      },
      "disableClickOutside": true
    },
    on: {
      "close": function($event) {
        _vm.showAddCabinet = false
      }
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16abc856"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Cabinets/index.vue
// module id = 632
// module chunks = 1